import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import DashboardLayout from "./layouts/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import User from "./pages/User";
import CronActivities from "./pages/CronActivities";
import ProductList from "./pages/ProductList";
import Register from "./pages/Register";
import { Navigate } from "react-router-dom";
import PublicRoute from "./layouts/PublicRoute";
import ProtectedRoute from "./layouts/ProtectedRoute";
import ContentOwner from "./pages/ContentOwner";
import ContractList from "./pages/ContractList";
import Earnings from "./pages/Earnings";
import Payouts from "./pages/Payouts";
import AllContracts from "./pages/AllContracts";
import RoleRoute from "./components/RoleRoute";
import EarningList from "./pages/EarningList";
import PayoutList from "./pages/PayoutList";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route element={<RoleRoute allow={["Admin", "Manager"]} />}>
            <Route path="users" element={<User />} />
            <Route path="cron-activities" element={<CronActivities />} />
          </Route>
          <Route path="products" element={<ProductList />} />
          <Route path="contracts" element={<AllContracts />} />
          <Route path="earnings" element={<EarningList />} />
          <Route path="payouts" element={<PayoutList />} />
          <Route
            path="products/:productId/content-owners"
            element={<ContentOwner />}
          />
          <Route
            path="content-owner/:contentOwnerId/contracts"
            element={<ContractList />}
          />
          <Route
            path="content-owner/:contentOwnerId/earnings"
            element={<Earnings />}
          />
          <Route
            path="content-owner/:contentOwnerId/payouts"
            element={<Payouts />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
